import { useEffect, useState } from "react";
import Logo from "../image/astrotalk-logo.png";

const PageLoading = ({ loading }) => {
    const [show, setShow] = useState(loading);

    useEffect(() => {
        let timer;

        if (loading) {
            setShow(true);
        } else {
            timer = setTimeout(() => {
                setShow(false);
            }, 1000);
        }

        document.body.style.overflow = loading ? "hidden" : "auto";
        
        return () => clearTimeout(timer);
    }, [loading]);

    if (!show) return null;

    return (
        <div className={`loader_page ${!loading ? "fade-out" : ""}`}>
            <div className="loader"></div>
            <div className="absolute">
                <img
                    src={Logo}
                    className="w-[50px] h-[50px] rounded-full"
                    alt="Logo"
                />
            </div>
        </div>
    );
};

export default PageLoading;
